module.exports = "/_next/static/images/video_id_7100715079414336810-104c478f1fd664767969784c0f64f3a7.jpg";